module.exports = __webpack_public_path__ + "img/sparbanken.ebfd2c58.jpg";